/**
 * Rectangular 4px pill for system state — Destroyed, Ready, Failed, Beta.
 * Outline only: filled pills are reserved for the log level badges.
 */
export type StatusTone = 'ok' | 'warn' | 'error' | 'info' | 'idle';

const TONES: Record<StatusTone, string> = {
  ok: 'text-state-ok-soft border-state-ok-soft',
  warn: 'text-state-warn border-state-warn',
  error: 'text-state-err border-state-err',
  info: 'text-action-soft border-action-soft',
  idle: 'text-navy-300 border-navy-400',
};

const StatusPill = ({ children, tone = 'idle', className = '' }: {
  children: React.ReactNode,
  tone?: StatusTone,
  className?: string,
}) => (
  <span
    className={`flex-none inline-block border rounded-[4px] px-[7px] py-[3px] text-ds-105 font-semibold uppercase leading-none tracking-[0.04em] ${TONES[tone]} ${className}`}
  >
    {children}
  </span>
)

export default StatusPill
